const styles = (theme) => ({
  root: {
    cursor: "none !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "-1px",
    zIndex: 20,
    justifyContent: "center",
    width: "100%",
    background: "linear-gradient(180deg, #151515 0%, #000000 100%)",
    overflow: "hidden",
    padding: "0 9rem",
    paddingBottom: "26px",
    paddingTop: "10rem",
    position: "relative",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1200)]: {
      padding: "10rem 4rem 0 4rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1000)]: {
      padding: "0 1rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      paddingTop: "26px",
      paddingBottom: "26px",
    },
  },
  address: {
    cursor: "none !important",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    maxWidth: "1920px",
    zIndex: 10,
    margin: "auto",
    width: "100%",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  container: {
    cursor: "none !important",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      margin: "20px",
      width: "100%",
      alignItems: "center",
      textAlign: "center",
    },
  },
  primary: {
    cursor: "none !important",
    color: "white",
    margin: 0,
    fontSize: "1rem",
    letterSpacing: "0.02em",
    marginBottom: "10px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      marginBottom: "4px",
    },
  },
  secondary: {
    cursor: "none !important",
    color: "white",
    fontSize: "1rem",
    margin: "0",
    letterSpacing: "0.02em",
    lineHeight: "22.4px",
    fontFamily: "Aktiv Grotesk",
    textDecoration: "none",
  },
  copyright: {
    cursor: "none !important",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1920px",
    margin: "auto",
    marginTop: "45px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      marginTop: "20px",
      textAlign: "center",
    },
  },
  stamp: {
    cursor: "none !important",
    color: "white",
    fontSize: "14px",
    margin: "0",
    fontFamily: "Aktiv Grotesk",
    lineHeight: "150%",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      width: "100%",
    },
  },
  socialItems: {
    cursor: "none !important",
    margin: "10px",
  },
  a: {
    cursor: "none !important",
    margin: "0",
    textDecoration: "none",
    color: "inherit",
  },
  pageLogo: {
    zIndex: "100",
  },
  social: {
    cursor: "none !important",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
      width: "100%",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      marginTop: "20px",
      width: "auto",
    },
  },
});

export default styles;
